import cookie from 'react-cookie';

export default {
  getUserId: () => {
    const content = cookie.load('SC') || '';

    const accountIdKV = content
      .split('&')
      .filter(params => params.match(/RC\.ACCT=/))
      .map(params => params.split('='))
      .map(params => params[1]);

    const accountId = accountIdKV.length ? accountIdKV[0] : null;

    return accountId;
  },
  getADB: () => {
    const content = cookie.load('ADB') || '';

    return content;
  },
  isAuth: () => {
    const content = cookie.load('isAuth') || '';

    return content;
  }
};



/** WEBPACK FOOTER **
 ** ./client/util/cookie.js
 **/